<div class="stick-top">
  <mat-toolbar><mat-icon>build</mat-icon> Server Request</mat-toolbar>
  <div class="hbox lightly-padded button-bar">
    <button *ngIf="hardwareRequestId" mat-raised-button class="primary" [routerLink]="['/hardwareRequests', hardwareRequestId, 'serverRequest', 0]">
      <mat-icon aria-label="Create a new Server Request">add</mat-icon>
      Create a new Server Request
    </button>
  </div>
</div>

<div class="padded">
  <table class="basicTable">
    <thead>
    <tr>
      <th *ngIf="auth.isCompanyAdmin()" style="width: 75px;">
        <div class="vbox">
          Company
          <micro-company-select [(companyId)]="filter.companyId"></micro-company-select>
        </div>
      </th>
      <!-- <th *ngIf="!hardwareRequestId"><div class="vbox">Request Number<input [(ngModel)]="filter.requestNumber"></div></th> -->
      <th><div class="vbox">Requested By<input [(ngModel)]="filter.requestedBy"></div></th>
      <th><div class="vbox">Server Name<input [(ngModel)]="filter.serverName"></div></th>
      <th><div class="vbox">Environment<input [(ngModel)]="filter.environment"></div></th>
      <th><div class="vbox">Server Type<input [(ngModel)]="filter.serverType"></div></th>
      <th><div class="vbox">OS<input [(ngModel)]="filter.os"></div></th>
      <th><div class="vbox">OS Version<input [(ngModel)]="filter.osVersion"></div></th>
      <th><div class="vbox">Site<input [(ngModel)]="filter.site"></div></th>
      <th><div class="vbox">CPU<input [(ngModel)]="filter.cpu"></div></th>
      <th><div class="vbox">RAM<input [(ngModel)]="filter.ram"></div></th>
      <th><div class="vbox">Node<input [(ngModel)]="filter.node"></div></th>
      <th><div class="vbox">Hosting Platform<input [(ngModel)]="filter.hostingPlatform"></div></th>
      <th><div class="vbox">Cluster<input [(ngModel)]="filter.cluster"></div></th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let element of dataSource.data">
      <td *ngIf="auth.isCompanyAdmin()"><micro-company-lookup [companyId]="element.companyId"></micro-company-lookup></td>
      <!-- <td *ngIf="!hardwareRequestId"><a routerLink="/hardwareRequests/{{element.requestId}}">{{element.requestNumber}}</a></td> -->
      <td><a routerLink="/users/{{element.requestedBy}}">{{element.requestedByName}}</a></td>
      <td><a [routerLink]="['/hardwareRequests', element.requestId, 'serverRequest', element.id]">{{element.serverName}}</a></td>
      <td><a routerLink="/domain/environments/{{element.environmentId}}">{{element.environmentName}}</a></td>
      <td>{{element.serverSize}}</td>
      <td>{{element.osName}}</td>
      <td><a routerLink="/osVersions/{{element.osVersionId}}">{{element.osVersionName}}</a></td>
      <td><a routerLink="/site/{{element.siteId}}">{{element.siteName}}</a></td>
      <td>{{element.cpu}}</td>
      <td>{{element.ram}}</td>
      <td>{{element.node}}</td>
      <td><a routerLink="/hostingPlatforms/{{element.hostingPlatformId}}">{{element.hostingPlatformName}}</a></td>
      <td>{{element.clusterId}}</td>
    </tr>
    <tr *ngIf="dataSource.data?.length === 0"><td colspan="100"><em>No results found</em></td></tr>
    </tbody>
    <tfoot><tr><td colspan="100">
      <mat-paginator #paginator (page)="reload()"></mat-paginator>
    </td></tr></tfoot>
  </table>
</div>
